var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLandmarkFlag = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 20.9884C1.5 20.5677 1.83855 20.2268 2.25618 20.2268H21.7438C22.1614 20.2268 22.5 20.5677 22.5 20.9884C22.5 21.409 22.1614 21.75 21.7438 21.75H2.25618C1.83856 21.75 1.5 21.409 1.5 20.9884Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.9419C3 17.5213 3.33855 17.1803 3.75618 17.1803H20.2438C20.6614 17.1803 21 17.5213 21 17.9419C21 18.3625 20.6614 18.7035 20.2438 18.7035H3.75618C3.33855 18.7035 3 18.3625 3 17.9419Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.66367H6V14.196H4.5V9.66367Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.75H10.5V14.196H9V9.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.66367H15V14.196H13.5V9.66367Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.66367H19.5V14.196H18V9.66367Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.196H19.5V14.9514C19.5 15.3686 19.1642 15.7068 18.75 15.7068H5.25C4.83579 15.7068 4.5 15.3686 4.5 14.9514V14.196Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9C3 8.58579 3.33579 8.25 3.75 8.25H20.25C20.6642 8.25 21 8.58579 21 9V9C21 9.41421 20.6642 9.75 20.25 9.75H10.5H3.75C3.33579 9.75 3 9.41421 3 9V9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3C11.25 2.58579 11.5858 2.25 12 2.25H12.75V9.75H11.25V3Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2.25H15.75V3.75H12.75V2.25Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2.25H16.5C16.9142 2.25 17.25 2.58579 17.25 3V6C17.25 6.41421 16.9142 6.75 16.5 6.75H15.75V2.25Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5.25H15.75V6.75H12.75V5.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLandmarkFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/landmark-flag.f9f25d70b5ab1b794443943fa19c9684.svg";